import Cookie from 'js-cookie';

import { defaultAuthenticationState } from 'state/defaults';
import { LOGGED_IN_JWT_COOKIE } from 'utils/constants';
import { END_CUSTOMER } from './userTypes';

export const parseJwt = (token) => {
  let parsedData = {};

  try {
    const base64Jwt = token.split('.')[1].replace('-', '+').replace('_', '/');
    parsedData = JSON.parse(window.atob(base64Jwt));
  } catch (e) {}

  return parsedData;
};

export const getLoggedInJwtCookie = () => Cookie.get(LOGGED_IN_JWT_COOKIE);

const getAccountName = (accountData, parsedAuthData) => {
  if (parsedAuthData.userType === END_CUSTOMER) {
    return parsedAuthData.Account;
  } else {
    return accountData.accountName || parsedAuthData.Account;
  }
};

export const getAuthFromStorage = () => {
  const loggedInUserEcommJWT = getLoggedInJwtCookie();
  const accountData = JSON.parse(localStorage.getItem('current-account')) || {};

  // If the cookie is missing the user is not isAuthenticated
  // so we will do nothing
  if (!loggedInUserEcommJWT) {
    console.error('Missing Auth Token');
    return defaultAuthenticationState;
  }

  // Get jwt data object
  const parsedAuthData = parseJwt(loggedInUserEcommJWT);

  if (
    !parsedAuthData.Account ||
    !parsedAuthData.userType ||
    !parsedAuthData.AccountSFid ||
    !parsedAuthData.ECommerceAccess
  ) {
    console.error('Auth Token Missing Required Data', parsedAuthData);
    return defaultAuthenticationState;
  }

  // Return an object with the auth data
  return {
    isAuthenticated: true,
    account: getAccountName(accountData, parsedAuthData),
    accountId: parsedAuthData.AccountSFid,
    endCustomerAccountId:
      parsedAuthData.userType === 'END_CUSTOMER'
        ? parsedAuthData.AccountSFid
        : accountData.accountId || '',
    varAccountId: parsedAuthData.userType === 'VAR' ? parsedAuthData.AccountSFid : '',
    ecomAccess: parsedAuthData.EcomAccess && parsedAuthData.EcomAccess.toLowerCase() === 'true',
    ecomCheckout:
      parsedAuthData.EcomCheckout && parsedAuthData.EcomCheckout.toLowerCase() === 'true',
    eCommerceAccess: parsedAuthData.ECommerceAccess || [],
    userSFid: parsedAuthData.UserSFid,
    fullName: `${parsedAuthData.FirstName} ${parsedAuthData.LastName}`,
    email: parsedAuthData.email,
    contactId: parsedAuthData.ContactId,
    userType: parsedAuthData.userType,
    userName: parsedAuthData.username,
    jwt: loggedInUserEcommJWT,
  };
};

export const getQuoteFromStorage = ({ defaultCurrencyCode = 'USD' } = {}) => {
  const storageQuoteData = JSON.parse(localStorage.getItem('current-quote'));

  return {
    quoteName: storageQuoteData?.quoteName || null,
    quoteTotal: storageQuoteData?.total || 0,
    currencyCode: storageQuoteData?.currencyCode || defaultCurrencyCode,
  };
};

export const getCurrentAccountFromStorage = () => {
  const currentAccountData = JSON.parse(localStorage.getItem('current-account'));
  return currentAccountData || {};
};
